module.exports = __webpack_public_path__ + "img/one-line-vehicle-row-hyundai.13ced45a.png";